/*
 * Copyright (c) 2022. American Express Company
 */

import React from 'react';

import { ProgressBarViewModel } from 'src/types/view-models/atoms/progress-bar.view.model';
import styles from './progressBar.module.scss';

export default function ProgressBar({ percentage, compact }: ProgressBarViewModel): JSX.Element {
    const classNames: string[] = [styles.progressBar];
    if (compact) classNames.push(styles.compact);

    return (
        <div className={classNames.join(' ')}>
            <div style={{ width: `${percentage}%` }} />
        </div>
    );
}
